import { render, staticRenderFns } from "./CelebrationDocument.vue?vue&type=template&id=e72610be&"
import script from "./CelebrationDocument.vue?vue&type=script&lang=js&"
export * from "./CelebrationDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports